import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

import { PartialPreferences } from "./preferences";

export function usePreferencesGAUserProperties(): usePreferencesGAUserPropertiesReturn {
  return useLazyContext(PreferencesGAUserPropertiesContext);
}

export type usePreferencesGAUserPropertiesReturn = {
  updatePreferences: (preferences: PartialPreferences) => void;
};

export const PreferencesGAUserPropertiesContext =
  createContext<LazyValue<usePreferencesGAUserPropertiesReturn>>(undefined);
